import { Button, Result, Table } from 'antd'
import UsePaymentDetailsHook from './hooks'
import Styles from './submit.module.scss'
import { useState } from 'react'
import { formatterPrice } from '@/tools/util'

const SubmitResult = () => {
  const { state, clickResult, clickNext } = UsePaymentDetailsHook()
  const [currentPage, setCurrentPage] = useState(1)
  const { dataSource } = state
  const columns = [
    {
      key: 'code',
      dataIndex: 'code',
      title: '编码',
      render: (text: string, record: any) => text || record.tempCode,
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
      render: (text: string, record: any) => text || record.basicUnitName,
    },
    {
      key: 'referenceSupplyPrice',
      dataIndex: 'referenceSupplyPrice',
      title: '参考供货价',
      render: (text: string, record: any) =>
        formatterPrice(text) || formatterPrice(record.purchasePrice),
    },
  ]
  return (
    <div className={Styles['container']}>
      <Result
        status="success"
        title="提交成功"
        subTitle="您提交了以下物料，等待审批通过后，即可在我的物料中使用~"
      />
      <div style={{ padding: '0 25px' }}>
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            pageSize: 5,
            total: dataSource.length,
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
            showTotal: (total) => `共${total}条`,
          }}
        />
      </div>
      <div className={Styles['button-line']}>
        <Button
          size="large"
          className={Styles['submit-button']}
          onClick={clickResult}
        >
          查看结果
        </Button>
        <Button
          type="primary"
          size="large"
          className={Styles['submit-button']}
          onClick={clickNext}
        >
          继续新增
        </Button>
      </div>
    </div>
  )
}

export default SubmitResult
import { Button, Result, Table } from 'antd'
import UsePaymentDetailsHook from './hooks'
import Styles from './submit.module.scss'
import { useState } from 'react'
import { formatterPrice } from '@/tools/util'

const SubmitResult = () => {
  const { state, clickResult, clickNext } = UsePaymentDetailsHook()
  const [currentPage, setCurrentPage] = useState(1)
  const { dataSource } = state
  const columns = [
    {
      key: 'code',
      dataIndex: 'code',
      title: '编码',
      render: (text: string, record: any) => text || record.tempCode,
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
      render: (text: string, record: any) => text || record.basicUnitName,
    },
    {
      key: 'referenceSupplyPrice',
      dataIndex: 'referenceSupplyPrice',
      title: '参考供货价',
      render: (text: string, record: any) =>
        formatterPrice(text) || formatterPrice(record.purchasePrice),
    },
  ]
  return (
    <div className={Styles['container']}>
      <Result
        status="success"
        title="提交成功"
        subTitle="您提交了以下物料，等待审批通过后，即可在我的物料中使用~"
      />
      <div style={{ padding: '0 25px' }}>
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            pageSize: 5,
            total: dataSource.length,
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
            showTotal: (total) => `共${total}条`,
          }}
        />
      </div>
      <div className={Styles['button-line']}>
        <Button
          size="large"
          className={Styles['submit-button']}
          onClick={clickResult}
        >
          查看结果
        </Button>
        <Button
          type="primary"
          size="large"
          className={Styles['submit-button']}
          onClick={clickNext}
        >
          继续新增
        </Button>
      </div>
    </div>
  )
}

export default SubmitResult
